import Api from "@/api/api"

import { MBasic, IJuheGameItem, IArticle } from "@/api/modules/basic"
import { ITableData, TableData } from "@/utils/base"
import { ActionContext } from "vuex"

interface IState {
  links: MBasic.FriendlyLink[]
  informations: MBasic.Information[]
  content: string
  maps: MBasic.IMapItem[]
  seoChoice: ITableData<MBasic.ISeoChoiceItem>
  juheGameList: IJuheGameItem[]
  juheArticleList: IArticle[]
}

export const basic = {
  namespaced: true,
  state: () => ({
    links: null,
    informations: null,
    content: null,
    maps: null,
    seoChoice: new TableData({}),
    juheGameList: null,
    juheArticleList: null
  }),
  getters: {
    links: (state: IState) => state.links,
    informations: (state: IState) => state.informations,
    content: (state: IState) => state.content,
    maps: (state: IState) => state.maps,
    seoChoice: (state: IState) => state.seoChoice,
    juheGameList: (state: IState) => state.juheGameList,
    juheArticleList: (state: IState) => state.juheArticleList
  },
  mutations: {
    SET_INFO: (state: IState, { links, informations }) => {
      state.links = links
      state.informations = informations
    },
    SET_CONTENT: (state: IState, { content }) => {
      state.content = content
    },
    SET_MAPS: (state: IState, { maps }) => {
      state.maps = maps
    },
    SET_SEO_CHOICE: (state: IState, data: IState["seoChoice"]) => {
      state.seoChoice = Object.assign(state.seoChoice, data)
    },
    SET_JUHE_GAMES: (state: IState, { juheGameList }) => {
      state.juheGameList = juheGameList
    },
    SET_JUHE_ARTICLES: (state: IState, { juheArticleList }) => {
      state.juheArticleList = juheArticleList
    }
  },
  actions: {
    FETCH_INFO: ({ commit }) => {
      return Api.basic.info().then(res =>
        commit("SET_INFO", {
          links: res.data.friendly_links,
          informations: res.data.informations
        })
      )
    },
    FETCH_CONTENT: ({ commit }, { _id }) => {
      return Api.basic.getContent(_id).then(res =>
        commit("SET_CONTENT", {
          content: res.data.content
        })
      )
    },
    FETCH_MAPS: ({ commit }) => {
      return Api.basic.maps().then(res =>
        commit("SET_MAPS", {
          maps: res.data
        })
      )
    },
    FETCH_SEO_CHOICE: ({ commit }) => {
      return Api.basic
        .seoChoice({ page: 1, page_size: 20 })
        .then(res => {
          commit("SET_SEO_CHOICE", {
            data: res.data,
            page: 1,
            page_size: 20,
            finished: parseInt(res.headers.total) < 20,
            total: parseInt(res.headers.total) || 0
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    FETCH_JUHE_GAMES: ({ commit }) => {
      return Api.basic.juheGames().then(res =>
        commit("SET_JUHE_GAMES", {
          juheGameList: res.data
        })
      )
    },
    FETCH_JUHE_ARTICLES: ({ commit }) => {
      return Api.basic.juheArticles().then(res =>
        commit("SET_JUHE_ARTICLES", {
          juheArticleList: res.data
        })
      )
    }
  }
}
